// extracted by mini-css-extract-plugin
module.exports = {"title":"signUpInvitation_title__2ZHd2","text":"signUpInvitation_text__2P4ON","image":"signUpInvitation_image__3adNS","btn":"signUpInvitation_btn__2u1qI"};
    if(module.hot) {
      // 1783592030486
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  